import { forwardRef } from "react";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { InputMask } from "@react-input/mask";
import { IMaskInput } from "react-imask";

import "./styles.css";

/* ------------------------- Máscaras ------------------------- */
const CellPhoneMask   = forwardRef((p, r) => <InputMask ref={r} {...p} mask="(__) _____-____"  replacement={{ _: /\d/ }} />);
const CredCardMask    = forwardRef((p, r) => <InputMask ref={r} {...p} mask="____ ____ ____ ____" replacement={{ _: /\d/ }} />);
const ExpCardMask     = forwardRef((p, r) => <InputMask ref={r} {...p} mask="__/__" replacement={{ _: /\d/ }} />);
const DocumentPFMask  = forwardRef((p, r) => <InputMask ref={r} {...p} mask="___.___.___-__"   replacement={{ _: /\d/ }} />);
const DocumentPJMask  = forwardRef((p, r) => <InputMask ref={r} {...p} mask="__.___.___/____-__" replacement={{ _: /\d/ }} />);
const CEPMask         = forwardRef((p, r) => <InputMask ref={r} {...p} mask="_____-___"         replacement={{ _: /\d/ }} />);
const ExpiresCardMask = forwardRef((p, r) => <InputMask ref={r} {...p} mask="__/__"             replacement={{ _: /\d/ }} />);
const CVVCardMask     = forwardRef((p, r) => <InputMask ref={r} {...p} mask="___"               replacement={{ _: /\d/ }} />);

export const BirthDateMask = forwardRef((p, r) => (
  <InputMask ref={r} {...p} mask="__/__/____" replacement={{ _: /\d/ }} />
));

const DocumentMask = forwardRef(function InputCpfCnpj(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      ref={ref}
      mask={[
        { mask: "000.000.000-00", regex: /^\d{0,11}$/ },
        { mask: "00.000.000/0000-00", regex: /^\d{12,14}$/ },
      ]}
      onAccept={(v) => onChange({ target: { value: v } })}
      overwrite={false}
    />
  );
});

/* ------------------------- Componente ------------------------- */
const InputText = ({
  label,
  rows,
  multiline,
  value,
  onChange,
  onBlur,
  type = "text",
  error,
  helperText,
  style,
  mask,
  maxLength,
  placeholder,
  prefix,
  suffix,
}) => {
  /* Mapas de máscara e inputMode */
  const masks = {
    cellphone: CellPhoneMask,
    card: CredCardMask,
    expcard: ExpCardMask,
    documentPF: DocumentPFMask,
    documentPJ: DocumentPJMask,
    cep: CEPMask,
    validity: ExpiresCardMask,
    cvv: CVVCardMask,
    identity: DocumentMask,
    birthdate: BirthDateMask,
  };

  const inputModes = {
    cellphone: "numeric",
    card: "numeric",
    expcard: "numeric",
    documentPF: "numeric",
    documentPJ: "numeric",
    identity: "numeric",
    cep: "numeric",
    cvv: "numeric",
  };

  /* Construir InputProps */
  const baseInputProps = {
    maxLength,
    inputMode: inputModes[mask] || undefined,
  };

  const adornmentProps = {
    ...(prefix ? { startAdornment: <InputAdornment position="start">{prefix}</InputAdornment> } : {}),
    ...(suffix ? { endAdornment:   <InputAdornment position="end">{suffix}</InputAdornment>   } : {}),
  };

  const maskProps =
    mask && masks[mask]
      ? {
          inputComponent: masks[mask],
        }
      : {};

  return (
    <div style={style}>
      <TextField
        className="upa-input-text"
        placeholder={placeholder}
        error={error}
        type={type}
        rows={rows}
        size="small"
        label={label}
        variant="outlined"
        multiline={multiline}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        helperText={error && helperText}
        inputProps={baseInputProps}
        InputProps={{ ...adornmentProps, ...maskProps }}
      />
    </div>
  );
};

export default InputText;
